module.exports = __webpack_public_path__ + "img/login-b2c.36f5c4d3.jpg";